// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input-1vg8pnKR","error":"error-2lnD21dD"};